module.exports = __webpack_public_path__ + "src/assets/videos/pano.webm";